let token;

class Epic {
  constructor() {
    if (!Epic.instance) {
      Epic.instance = this;
    }
    return Epic.instance;
  }

  isEpic = () => {
    return typeof token !== "undefined";
  };

  handleClick = (event) => {
    const targetElement = event.target;
    let hyperLink = null;
    if (targetElement.tagName === "a") {
      hyperLink = targetElement;
    } else {
      const closestElement = targetElement.closest("a");
      if (closestElement != null) {
        hyperLink = closestElement;
      }
    }

    if (
      hyperLink != null &&
      hyperLink.getAttribute("target") === "_blank" &&
      hyperLink.getAttribute("href") !== "#" &&
      hyperLink.getAttribute("data-epic-open-window") !== "false"
    ) {
      // Convert relative URLs to absolute
      const url = new URL(hyperLink.getAttribute("href"), window.location.href)
        .href;
      event.preventDefault();
      this.openExternalWindow(url);
    }
  };

  epicHyperspaceListener = (event) => {
    for (const type in event.data) {
      if (event.data.hasOwnProperty(type)) {
        const payload = event.data[type];
        if (type === "token") {
          token = payload;
          document.addEventListener("click", this.handleClick);
          break;
        }
      }
    }
  };

  openExternalWindow = (url) => {
    // This window method is required by EPIC to open target url in new window.
    if (typeof window !== "undefined") {
      window.parent.postMessage(
        // NOSONAR (verify origin)
        {
          token: token,
          action: "Epic.Clinical.Informatics.Web.OpenExternalWindow",
          args: url,
        },
        "*"
      );
    }
  };

  initiateHandshake = () => {
    if (typeof window !== "undefined") {
      window.addEventListener("message", this.epicHyperspaceListener, false);
      window.parent.postMessage(
        // NOSONAR (verify origin)
        { action: "Epic.Clinical.Informatics.Web.InitiateHandshake" },
        "*"
      );
    }
  };
}

export default Epic;
